import React, { Component } from "react";
import InstructorTutorial from "./InstructorTutorial";
import { updatesse } from '../../utils/updatesse';
import axios from "axios";
import $ from 'jquery';

class ParticipantStreams extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			waitingInSession: 0,
			waitingInLongue: 0,
			waitingRoomSetup: 0,
			currentUserData: JSON.parse(localStorage.getItem('userData')),
			sep: '~@$',
		}
	}
	componentDidMount(){
	}
	
	nextTutorial=(mod, ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		this.props.nextTutorial(mod); 
	}
	
	backTutorial=(mod, ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		this.props.backTutorial(mod);
	}
	
	finishTutorial=(mod, ev)=>{
		ev.preventDefault();
		ev.stopPropagation();
		this.props.finishTutorial(mod);
	}
	
	setNewUser=()=>{
		let sessionId = this.state.currentUserData.sessionData.id;
		axios.get(process.env.REACT_APP_API_URL+"/api/v1/user/"+sessionId+"/getAllSignupParticipant").then(res => {
			let participantList = res.data.responseData;
			let participantsAlreadyIn = JSON.parse(localStorage.getItem('tempUsers'));
			let allParticipantsInIds = [];
			
			if ( participantsAlreadyIn )
				{
					for ( var c = 0; c<participantsAlreadyIn.length; c++ )
						{
							allParticipantsInIds.push(participantsAlreadyIn[c]['id']);
						}
				}
			
		
			for ( var i = 0; i<participantList.length; i++ )
				{
					
					if ( allParticipantsInIds.indexOf(participantList[i]['userId']) == - 1 )
						{
							if ( window['addToSessionUsers'] )
								{
									participantList[i]['id'] = participantList[i]['userId'];
									participantList[i]['userType'] = 2;
									window['addToSessionUsers'](participantList[i]);
								}
						}
					
				} 		
		}).catch(err =>{ console.log('-----error', err);});
	}
	
	render() {
		return (
			<div className={"participants_stream_container " + (this.props.state.sessionStartedByHost ? "host_streams"+this.props.state.usersOnScreen : "")}>
				<div className={"sessionTextMsgHolder " + (this.props.state.sessionStartedByHost ? 'd-none' : '') + (this.props.state.tutorialMessNum > 6 ? 'd-none' : '') }>
					<div className="holdNotActive" >
					{/* <div className="notActiveText" >There are 
						{this.state.waitingInLongue - this.state.waitingInSession > 0 ?
							<span className="notActiveNum" > {this.state.waitingInLongue - this.state.waitingInSession} </span> 
							:
							<span className="notActiveNum" > 0 </span> 
						}
						members waiting in the lounge.</div>
						{this.state.waitingInSession > 0 &&
							<div className="notActiveText">There are {this.state.waitingInSession} members waiting in the class.</div>
					} */}
						{(this.state.waitingInSession > 0 && this.state.waitingInLongue > 0) &&
							<div className="notActiveText">Members are waiting, {this.state.waitingInLongue} in waiting lounge and {this.state.waitingInSession} already in the class.</div>
						}
						{(this.state.waitingInSession > 0 && this.state.waitingInLongue == 0 ) &&
							<div className="notActiveText">Members are waiting, {this.state.waitingInSession} already in the class.</div>
						}
						{(this.state.waitingInSession == 0 && this.state.waitingInLongue > 0 ) &&
							<div className="notActiveText">Members are waiting, {this.state.waitingInLongue} in waiting lounge.</div>
						}
						{(this.state.waitingInSession == 0 && this.state.waitingInLongue == 0) &&
							<div className="notActiveText">There are 0 members waiting in the lounge.</div>
						}

						{ this.props.canStartSessionRTM ? 
							<div className="startActBtn startSessionBtn" onClick={this.props.startSession}>
								Start class
								{this.props.state.tutorialMessNum == 3 &&
									<InstructorTutorial
									nextTutorial={this.nextTutorial}
									backTutorial={this.backTutorial}
									finishTutorial={this.finishTutorial}
									state={this.state}>
									</InstructorTutorial>
								}
							</div>
							:
							<div className="startActBtn startSessionBtn inactButton" onClick={this.props.startSessionInfo}>Start class</div>
						}

						{this.props.state.signedUpUsers > 0 &&
							<div className="viewListText"><span onClick={() => this.props.showParticipantList(1)}>View member list</span></div>
						}
					</div>
				</div>
				<div className={"videosActiveHolder " + (!this.props.state.sessionStartedByHost ? 'd-none' : '')} id="hostParticipantStreamsList">
					<div className="network_status_container" >
						<div className="whoIsSpeaking_containter d-none" >
							<div className="micIcon_instructor" ></div>
							<div className="currentSpeakerName" ></div>
						</div>
						<div className="poorNetwork d-none" id="poorNetwork"></div>
					</div>
				</div>
				{this.props.state.tutorialMessNum > 6 &&
					<div className="videosActiveHolder">
						<div className="participantStreamPart">
							<div className="raiseHandPartHolder" >
								{this.props.state.tutorialMessNum == 7 &&
									<InstructorTutorial
									nextTutorial={this.nextTutorial}
									backTutorial={this.backTutorial}
									finishTutorial={this.finishTutorial}
									state={this.state}>
									</InstructorTutorial>
								}
							</div>
							<div className="participantStreamName">
								<div className="nameHoldMax">Sarah F</div>
								<div className="zoomMemberIcon"></div>
							</div>
							<div className="cameraMicHolder" >	
								<div className="noVideoPartHolder">
									<div className="muteVideo" ></div>
									{this.props.state.tutorialMessNum == 8 &&
										<InstructorTutorial
										nextTutorial={this.nextTutorial}
										backTutorial={this.backTutorial}
										finishTutorial={this.finishTutorial}
										state={this.state}>
										</InstructorTutorial>
									}
								</div>
								<div className="micMutePartHolder micUnMutePartHolder">
									{this.props.state.tutorialMessNum == 9 &&
										<InstructorTutorial
										nextTutorial={this.nextTutorial}
										backTutorial={this.backTutorial}
										finishTutorial={this.finishTutorial}
										state={this.state}>
										</InstructorTutorial>
									}
								</div>
							</div>
							<div class="noVideoInitialsHolder tutorial_stream_img">
							</div>
						</div>
					</div>
				}
			</div>
	)}
}
export default ParticipantStreams;
